import { Link } from 'gatsby';
import React from 'react';
import * as classes from './Footer.module.css';

function Footer() {
  return (
    <div className={classes.container} >
      <div className={classes.contentContainer}>
        <div className={classes.emailRow}>
          Email us at: <a href="mailto:technotoolsapps@gmail.com">technotoolsapps@gmail.com</a>
        </div>
        <div className={classes.bottomContainer}>
          <div>© {new Date().getFullYear()} Techno Tools Apps.</div>
          <div className={classes.linksRow}>
            <Link to="/terms-of-service" style={{marginRight: 20}}>Terms of Service</Link>
            <Link to="/priacy-policy">Privacy Policy</Link>
          </div>
        </div>
        <div>
        </div>
      </div>
    </div>
  )
}

export default Footer;